import { Box, Typography } from "@mui/material";
import SkeletonWrapper from "../../../common/components/functional/skeletonWrapper/SkeletonWrapper";
import {
  formatTimeRange,
  getFormattedDate,
} from "../../../common/helpers/formatDateTime";
import { ReactComponent as CalendarIcon } from "../../../common/icons/calendar.svg";
import { ReactComponent as ClockIcon } from "../../../common/icons/clock.svg";
import { ReactComponent as LocationPinIcon } from "../../../common/icons/locationPin.svg";
import { Address } from "../../customer/types/queries";
import { PreviewShiftContainer, PreviewShiftItem } from "./styles";
import { ShiftDetailsType } from "./types";

type Props = {
  shiftDetails: ShiftDetailsType[];
  multipleShifts: boolean;
  address: Address;
};

const PreviewShifts = ({ shiftDetails, multipleShifts, address }: Props) => {
  const formattedAddress = `${address.street}, ${address.zip} ${address.city}`;

  const getDate = (date: Date | null) =>
    multipleShifts
      ? getFormattedDate(date, true)
      : getFormattedDate(date, true, { weekday: "cccc" });

  return (
    <>
      {shiftDetails.map((shift) => {
        const date = getDate(shift.date);
        const time = formatTimeRange(shift.time, "long");

        return (
          <PreviewShiftContainer key={shift.id} multipleShifts={multipleShifts}>
            <PreviewShiftItem>
              <CalendarIcon style={{ minWidth: "18px" }} />
              <SkeletonWrapper value={date} width="80px">
                <Typography
                  sx={{ fontWeight: 600, fontSize: "14px" }}
                  variant="header"
                >
                  {date}
                </Typography>
              </SkeletonWrapper>
            </PreviewShiftItem>
            <PreviewShiftItem>
              <ClockIcon style={{ minWidth: "18px" }} />
              <SkeletonWrapper value={time} width="130px">
                <Typography
                  sx={{ fontWeight: 600, fontSize: "14px" }}
                  variant="header"
                >
                  {time}
                </Typography>
              </SkeletonWrapper>
            </PreviewShiftItem>
          </PreviewShiftContainer>
        );
      })}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
        }}
      >
        <LocationPinIcon style={{ minWidth: "18px" }} />
        <SkeletonWrapper value={formattedAddress} width="320px">
          <Typography
            variant="header"
            sx={{ fontWeight: 600, fontSize: "14px" }}
          >
            {formattedAddress}
          </Typography>
        </SkeletonWrapper>
      </Box>
    </>
  );
};

export default PreviewShifts;
